import { formValueSelector } from 'redux-form';
import { getPrice, getSelected, getGraphQlSelection } from '../single-choice/utils/selection';
import { LOUNGE } from '../products';
import getIcon from './icon';
import Lounge from './components/Lounge';
const formSection = LOUNGE.name;
const getAvailability = form => state => {
  var _formData$cartBreakDo;
  const formData = formValueSelector(form)(state, formSection);
  return (_formData$cartBreakDo = formData.cartBreakDown) !== null && _formData$cartBreakDo !== void 0 ? _formData$cartBreakDo : null;
};
export const lounge = {
  formSection,
  getIcon,
  getPrice: getPrice.bind(null, formSection),
  getSelected: getSelected.bind(null, formSection),
  getGraphQlSelection: getGraphQlSelection(formSection, 'none'),
  getAvailability,
  ...LOUNGE
};
export default Lounge;
//# sourceMappingURL=index.js.map